import { toast } from "react-toastify";
import Api from "../../../axios";
import { callLoader } from "../../../common/actions/app";

let ACTION_AUTHENTICATION_COLLABORATOR = {
    type: 'AUTHENTICATION_COLLABORATOR',
    payload: {
        document: '',
        name: '',
        companyUnit: '',
        role: ''
    },
};

let ACTION_AUTHENTICATION_VEHICLE = {
    type: 'AUTHENTICATION_VEHICLE',
    payload: {
        code: '',
        identity: '',
        companyUnit: '',
    },
};

let callAuthenticationCollaboratorGet = (document, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.get('/totem/collaborator/' + document).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        ACTION_AUTHENTICATION_COLLABORATOR.payload.document = data.document
        ACTION_AUTHENTICATION_COLLABORATOR.payload.name = data.name
        ACTION_AUTHENTICATION_COLLABORATOR.payload.companyUnit = data.companyUnit
        ACTION_AUTHENTICATION_COLLABORATOR.payload.role = data.role
        dispatch(ACTION_AUTHENTICATION_COLLABORATOR)
        success()
    })
}

let callAuthenticationCollaboratorClear = () => (dispatch) => {
    ACTION_AUTHENTICATION_COLLABORATOR.payload.document = ''
    ACTION_AUTHENTICATION_COLLABORATOR.payload.name = ''
    ACTION_AUTHENTICATION_COLLABORATOR.payload.companyUnit = ''
    ACTION_AUTHENTICATION_COLLABORATOR.payload.role = ''
    dispatch(ACTION_AUTHENTICATION_COLLABORATOR)
}

let callAuthenticationVehicleGet = (document, code, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.get('/totem/vehicle/' + document + '/' + code).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        ACTION_AUTHENTICATION_VEHICLE.payload.code = data.code
        ACTION_AUTHENTICATION_VEHICLE.payload.identity = data.identity
        ACTION_AUTHENTICATION_VEHICLE.payload.companyUnit = data.companyUnit
        dispatch(ACTION_AUTHENTICATION_VEHICLE)
        success()
    })
}

let callAuthenticationVehicleClear = () => (dispatch) => {
    ACTION_AUTHENTICATION_VEHICLE.payload.code = ''
    ACTION_AUTHENTICATION_VEHICLE.payload.identity = ''
    ACTION_AUTHENTICATION_VEHICLE.payload.companyUnit = ''
    dispatch(ACTION_AUTHENTICATION_VEHICLE)
}

let callAuthenticationCollaboratorValidatePost = (document, photo, success = () => { }, error = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.post('/totem/collaborator/' + document, { photo: photo }).then((data) => {
        dispatch(callLoader(false))
        if (!data) {
            error()
            return
        }

        toast.success(data.msg)
        success()
    })
}

let callAuthenticationOperationPost = (data = {}, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.post('/totem/operation', data).then((data) => {
        dispatch(callLoader(false))
        if (!data) {
            return
        }

        toast.success(data.msg)
        success()
    })
}

export { callAuthenticationOperationPost, callAuthenticationCollaboratorGet, callAuthenticationVehicleClear, callAuthenticationCollaboratorClear, callAuthenticationVehicleGet, callAuthenticationCollaboratorValidatePost, ACTION_AUTHENTICATION_COLLABORATOR, ACTION_AUTHENTICATION_VEHICLE }